// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import ConvoyMenu from './ConvoyMenu'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectAu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {





    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='8' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/20_000001.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>学习集团</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>合作伙伴</div>
                                <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>国际学习中心</div>
                            </div>
                            {this.state.currentTab == 0 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000002.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000003.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000004.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000005.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000006.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000021.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000023.jpg")} />
                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000007.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000008.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000009.jpg")} />
                            </div>}
                            {this.state.currentTab == 2 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000010.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000011.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000012.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000013.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000014.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000015.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000016.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000017.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000018.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/20_000019.jpg")} />
                            </div>}
                        </div>
                    </div>


                </div>
                <Footer />
            </div>

        );
    }
}

export default withRouter(ProjectAu);